import React, { useEffect, useState } from "react";
import { DropdownButton, FormControl, InputGroup, MenuItem } from "react-bootstrap";

const DEFAULT_LANGUAGE = 'ru';

export default ({ values, onChange, onBlur = null, inValid, ...props }) => {
    const [language, setLanguage] = useState(Object.keys(values)[0]);
    const [isValueChanged, setValueChanged] = useState(false);

    useEffect(() => {
        if (!isValueChanged) {
            return;
        }

        onBlur();
        setValueChanged(false);
    }, [isValueChanged]);

    function handleBlur(e) {
        Object.keys(values).forEach((key) => {
            if (key !== DEFAULT_LANGUAGE && !values[key]) {
                onChange[key](e);
            }
        })

        if (!!onBlur) {
            setValueChanged(true);
        }
    }

    return (
        <div>
            <InputGroup style={inValid ? {border: '1px solid red'} : {}}>
                <FormControl
                    {...props}
                    componentClass={props.type === 'textarea' ? 'textarea' : undefined}
                    value={values[language]}
                    onChange={onChange[language]}
                    onBlur={handleBlur}
                />
                <DropdownButton
                    id="language-select"
                    componentClass={InputGroup.Button}
                    title={language.toUpperCase()}
                    pullRight
                >
                    {Object.keys(values).map((language) => (
                        <MenuItem
                            key={language}
                            onClick={() => setLanguage(language)}
                        >
                            {language.toUpperCase()}
                        </MenuItem>
                    ))}
                </DropdownButton>
            </InputGroup>
            {props.maxLength && <div style={{width: '100%', textAlign: 'right', fontSize: '1rem'}}>{String(values[language]).length} / {props.maxLength}</div>}
        </div>
    );
}
